import adapterUtils from 'app/shared/utils/adapterUtils';
import Filter from 'app/shared/models/Filter';
import { filterUtils_getFilterLabels } from 'app/shared/utils/filterUtils';
import { adapt_reduxToQuery } from 'app/shared/flux/actions/FilterActions/adapters';
import queryUtils, { type QueryObject } from 'app/shared/utils/queryUtils';
import routeUtils from 'app/shared/utils/routeUtils';

type Building = unknown;

type BuildingGroupDto = {
  buildings?: Array<Building>;
};

type FilterProps = {
  listingTypes?: Array<string>;
  [key: string]: unknown;
};

type HomeHubCollectionProps = {
  collectionType?: string;
  buildingGroupDtos?: BuildingGroupDto;
  title?: string;
  filter?: FilterProps;
  resourceId?: string;
  numOfNewResults?: number;
  name?: string;
};

class HomeHubCollection {
  filter: Filter;
  collectionType: string;
  title: string;
  numOfNewResults: number;
  listings: Record<string, unknown>;
  filterSummary: unknown;
  name: string;
  url: string;

  constructor({
    collectionType = '',
    buildingGroupDtos,
    title = '',
    filter = {},
    resourceId = '',
    numOfNewResults = 0,
    name = '',
  }: HomeHubCollectionProps = {}) {
    const { listingTypes } = filter;
    // Convert listingTypes array to comma-separated string for Filter constructor
    const filterParams = {
      ...filter,
      listingTypes: Array.isArray(listingTypes) ? listingTypes.join(',') : listingTypes,
    };
    this.filter = new Filter(filterParams as Record<string, unknown>);
    this.collectionType = String(collectionType);
    this.title = String(title);
    this.numOfNewResults = Number(numOfNewResults);

    const processedListings: Array<{ maloneLotIdEncoded: string }> = adapterUtils.apiLimitedBuildingArrayToSummaryArray(
      buildingGroupDtos?.buildings || [],
      this.filter,
    );

    const listingsObj: Record<string, unknown> = {};
    processedListings.forEach((listing) => {
      listingsObj[listing.maloneLotIdEncoded] = listing;
    });
    this.listings = listingsObj;

    this.filterSummary = filterUtils_getFilterLabels(this.filter);
    this.name = String(name);

    if (listingTypes) {
      let searchSlug: string;
      if (this.collectionType === 'affordableApartments') {
        searchSlug = 'affordable-apartments-for-rent';
      } else if (this.collectionType === 'luxuryApartments') {
        searchSlug = 'luxury-apartments-for-rent';
      } else {
        searchSlug = 'apartments-for-rent';
      }
      const areaPath = routeUtils.buildAreaPath({ areaResourceId: resourceId, searchSlug });
      const queryObj = adapt_reduxToQuery({ filter: this.filter });
      // Type assertion needed: adapt_reduxToQuery returns Partial<ReduxAndSearchStateToQueryOutput>
      // which has string-typed properties for URL serialization, but queryUtils.stringify expects
      // QueryObject with native types (page: number, border: boolean) which it converts to strings.
      // The runtime behavior is correct - this assertion bridges the type mismatch.
      const query = queryUtils.stringify(queryObj as QueryObject);
      this.url = `${areaPath}${query}`;
    } else {
      this.url = '';
    }
  }
}

export default HomeHubCollection;
